import { Link } from 'react-router-dom';

function App() {
  return (
    <div>
      Home
      <Link to="/login">Login</Link>
    </div>
  );
}

export default App;
